// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__N7LGI","backButton":"styles_backButton__o_iVS","coursePageBreadcrumbsList":"styles_coursePageBreadcrumbsList__U7Qjw"};